import { Dropdown, MenuItem } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import React from "react";

const ProjectActionButton = ({
  availableActions,
  deleteProject,
  reaffectProject
}) => {
  return (
    <Dropdown
      pullRight
      id="project-actions-dropdown"
      className="dropdown-action-btn pull-right">
      <Dropdown.Toggle className="btn-wd btn-icon">
        <i className="fa fa-lg fa-check" />
        Action
      </Dropdown.Toggle>
      <Dropdown.Menu className="action-dropdown-menu">
        {availableActions.includes("DELETEPROJECT") ? (
          <MenuItem
            onClick={() => {
              console.log("call deleteProject()");
              deleteProject();
            }}
            eventKey="1">
            <i className="fa fa-lg fa-trash" />

            <FormattedMessage id="ids_deleteProject" />
          </MenuItem>
        ) : (
          <div />
        )}

        {availableActions.includes("REAFFECTPROJECT") ? (
          <MenuItem
            onClick={() => {
              console.log("call reaffectProject()");
              reaffectProject();
            }}
            eventKey="1">
            <i className="fa fa-lg fa-trash" />

            <FormattedMessage id="ids_reaffectProject1" />
            <br/>
            <FormattedMessage id="ids_reaffectProject2" />
          </MenuItem>
        ) : (
          <div />
        )}

      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProjectActionButton;
